var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    {
      staticClass: "text-body-2 text-info--text text-center",
      attrs: { "data-qa": "agreement_info" },
    },
    [
      _vm._v("\n  Оплачивая, вы соглашаетесь\n  с "),
      _c(
        "a",
        {
          staticClass: "text-info--text link-decoration-underline",
          attrs: {
            "data-qa": "agreement_info_offer_link",
            href: "/static/_v1/pd/documents/pdf/club/Правила_использования_опционов.pdf",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        [_vm._v("офертой")]
      ),
      _vm._v(" "),
      _setup.isMobile ? _c("br") : _vm._e(),
      _vm._v("\n  и "),
      _c(
        "a",
        {
          staticClass: "text-info--text link-decoration-underline",
          attrs: {
            "data-qa": "agreement_info_club_rules_link",
            href: "/static/_v1/pd/documents/pdf/club/Правила_участия_в_клубе.pdf",
            rel: "noopener noreferrer",
            target: "_blank",
          },
        },
        [_vm._v("правилами клуба")]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }